import { apiClient } from '@/lib/api/client';
import { getDataOrThrowApiError } from '@/lib/api/error';
import { orpcClient } from '@/lib/api/orpc/client';
import { PRESIGNED_POST_SIZE_LIMIT_MB, uploadViaPresignedPost } from '@/utils/uploadViaPresignedPost';
import type { CustomAppState, MdmConfigurationRes } from './type';
export const getIntegratableApp = async (appId: string) => {
  const res = await apiClient.GET('/v2/apps/{id}', {
    params: {
      path: {
        id: appId
      }
    }
  });
  return getDataOrThrowApiError(res);
};
const getPresignedUrl = async (filename: string) => {
  const res = await apiClient.GET('/v2/s3/presigned-url/image', {
    params: {
      query: {
        filename
      }
    }
  });
  return getDataOrThrowApiError(res);
};
type CustomAppAvatarBase = Pick<CustomAppState, 'appName' | 'category' | 'serviceUrl'>;

/** Custom App 定義（名称 / カテゴリ / URL / アバター等）の更新 */
export const patchCustomApp = async (softwareId: string, appState: CustomAppState) => {
  return orpcClient.software.integrationCustomApp({
    softwareId,
    ...appState
  });
};

/** Custom App アバター画像を S3 にアップロードし、object key を返す */
export const uploadCustomAppAvatar = async (file: File) => {
  const presignedUrlData = await getPresignedUrl(file.name);
  await uploadViaPresignedPost(presignedUrlData.url, presignedUrlData.fields, file, file.name, {
    maxFileSizeMb: PRESIGNED_POST_SIZE_LIMIT_MB.AVATAR_LOGO
  });
  return presignedUrlData.key;
};

/** Custom App のアバター更新（置換 / 削除） */
export const patchCustomAppAvatar = async (softwareId: string, base: CustomAppAvatarBase, avatar: {
  replaceAvatarObjectKey: string;
} | {
  removeAvatar: true;
}) => {
  return patchCustomApp(softwareId, {
    ...base,
    ...avatar
  });
};

// TODO: MDMエンドポイントがバックエンドで実装されたら有効化
export const getMdmConfiguration = (_appIntegrationId: string): Promise<MdmConfigurationRes> => {
  // const res = await apiClient.GET(
  //   "/v2/app-integrations/{id}/settings/mdm-configuration",
  //   {
  //     params: { path: { id: appIntegrationId } },
  //   },
  // );
  // return getDataOrThrowApiError(res);

  // 一時的なモック実装
  return Promise.resolve({
    tenantId: undefined,
    clientId: undefined,
    hasClientSecret: false,
    lastUpdated: undefined
  });
};

// Software data from app-integration
export const getSoftwareFromAppIntegration = async (appIntegrationId: string) => {
  const res = await apiClient.GET('/v2/software/app-integrations/{appIntegrationId}', {
    params: {
      path: {
        appIntegrationId
      }
    }
  });
  return getDataOrThrowApiError(res);
};